import React from 'react';

const NewPDF2 = ({ stroke, ...props }) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="none"
      d="M18.75 21.4059H5.25C5.05109 21.4059 4.86032 21.3269 4.71967 21.1862C4.57902 21.0456 4.5 20.8548 4.5 20.6559V4.15591C4.5 3.957 4.57902 3.76624 4.71967 3.62558C4.86032 3.48493 5.05109 3.40591 5.25 3.40591H14.25L19.5 8.65591V20.6559C19.5 20.8548 19.421 21.0456 19.2803 21.1862C19.1397 21.3269 18.9489 21.4059 18.75 21.4059Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M7 14.7572H8.17562C8.48742 14.7572 8.78644 14.6333 9.00692 14.4128C9.22739 14.1924 9.35125 13.8933 9.35125 13.5815C9.35125 13.2697 9.22739 12.9707 9.00692 12.7502C8.78644 12.5298 8.48742 12.4059 8.17562 12.4059H7V15.9328"
      stroke={stroke}
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M11.8799 15.9328C12.3476 15.9328 12.7962 15.747 13.1269 15.4163C13.4576 15.0856 13.6434 14.637 13.6434 14.1694C13.6434 13.7017 13.4576 13.2531 13.1269 12.9224C12.7962 12.5917 12.3476 12.4059 11.8799 12.4059H10.8513V15.9328H11.8799Z"
      stroke={stroke}
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M17.2007 12.4059H15.1434V15.9328"
      stroke={stroke}
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M16.9068 14.4633H15.1434"
      stroke={stroke}
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M14.25 3.40591V8.65591H19.5"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewPDF2;
